<section class="content-list-select scroll-hidden">
  <!-- Barra de navegación superior -->
  <nav class="navbar navbar-light bg-light p-0 content-nav">
    <div
      class="d-flex justify-content-between align-items-center vw-100 container-list"
    >
      <!-- Logo -->
      <a class="navbar-brand" [routerLink]="'/seleccionar-cliente'">
        <img src="assets/svg/logo_alicorp.svg" alt="Logo" />
      </a>

      <!-- Sección de perfil de usuario -->
      <div>
        <!-- Perfil en pantallas de escritorio -->
        <div class="content-img-perfil d-none d-md-block">
          <div class="img-user d-flex" [matMenuTriggerFor]="menuUser">
            <mat-icon>
              <img
                src="assets/image/selected-client-list/user-select.svg"
                alt="Icono de usuario"
                class="m-0 p-0"
              />
            </mat-icon>
          </div>
        </div>

        <!-- Perfil en pantallas móviles -->
        <div class="content-profile d-md-none">
          <mat-drawer-container class="hp-100 vw-100" autosize>
            <mat-drawer #drawerProfileOptions mode="over" position="end">
              <app-profile-responsive
                [optionsMenu]="options"
                [user]="user"
                [dateClients]="!!dateClients?.length"
                (closeModalProfile)="closeProfile($event)"
              ></app-profile-responsive>
            </mat-drawer>
            <mat-drawer-content>
              <div class="background-color">
                <div class="img-user d-flex" (click)="openProfile()">
                  <mat-icon>
                    <img
                      src="assets/image/selected-client-list/user-select.svg"
                      alt="Icono de usuario"
                      class="m-0 p-0"
                    />
                  </mat-icon>
                </div>
              </div>
            </mat-drawer-content>
          </mat-drawer-container>
        </div>
      </div>
    </div>
  </nav>

  <!-- Título y botón de descarga -->
  <div  #tableContainer class="py-3 px-3 container-body" (scroll)="onTableScroll($event)">
    <div class="container-binnacle-meetings py-3 px-4">
      <div class="d-flex justify-content-between font-regular fts-14 mb-8">
        <div class="d-flex align-items-center">
          <img
            src="assets/image/home-seller/icon-meeting.svg"
            height="20"
            alt="Icono de reunión"
            class="icon mr-8"
          />
          <h2
            class="font-bold-dali fts-24 fontw-700 m-0 h2-title show-desktop-tablet"
          >
            Bitácora de reuniones y planes
          </h2>
          <h2
            class="font-bold-dali fts-24 fontw-700 m-0 h2-title show-mobile text-ellipsis"
          >
            B. de reuniones y planes
          </h2>
        </div>
        <div class="register-btn">
          <ng-container *ngIf="isDataLoading; else buttonsAddSave">
            <div class="container-skeleton-button">
              <ngx-skeleton-loader
                count="1"
                appearance="line"
                [theme]="{
                  height: '40px',
                  width: '100%',
                  'border-radius': '4px',
                  'margin-bottom': '0px',
                  display: 'flex'
                }"
              >
              </ngx-skeleton-loader>
            </div>
          </ng-container>
          <ng-template #buttonsAddSave>
            <!-- Botón de registrar -->
            <button
              *ngIf="
                (!isAddingRow && !isRowBeingEdited() && !isServiceError) ||
                isLoadingRegistrationService ||
                isErrorRegistrationService
              "
              class="btn-back-new fts-14 font-semiBold d-flex align-items-center btn-add-custom"
              [ngClass]="{
                'btn-register-disabled':
                  isActionRetry ||
                  isLoadingRegistrationService ||
                  isErrorRegistrationService,
                'btn-add': !isActionRetry
              }"
              [disabled]="
                isActionRetry ||
                isLoadingRegistrationService ||
                isErrorRegistrationService
              "
              (click)="addNewRow()"
            >
              Registrar
              <mat-icon class="ml-8">add</mat-icon>
            </button>
            <ng-container
              *ngIf="
                (isAddingRow || isRowBeingEdited()) &&
                !(isLoadingRegistrationService || isErrorRegistrationService)
              "
            >
              <div
                class="d-flex align-items-center justify-content-end btn-add-custom"
              >
                <button
                  mat-flat-button
                  class="btn-cancel d-flex justify-content-center align-items-center mr-16"
                  (click)="
                    isAddingRow ? cancelAddRow(true) : cancelEditRow(true)
                  "
                >
                  Cancelar
                </button>

                <button
                  [matMenuTriggerFor]="menuIncompleteForm"
                  class="btn-back-new fts-14 font-semiBold d-flex align-items-center"
                  [ngClass]="{ 'btn-add': true }"
                  [disabled]="false"
                  #menuTriggerIncompleteForm="matMenuTrigger"
                  (click)="
                    isAddingRow
                      ? saveRow($event, menuTriggerIncompleteForm)
                      : editSaveRow($event, menuTriggerIncompleteForm)
                  "
                >
                  {{ successButton }}
                </button>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
      <!-- <div class="container-download-button">
        <span class="mr-16 text-download fontw-600">Descárgate la bitácora:</span>
        <button class="btn-green p-12 font-regular fts-14 fontw-600" pButton>
          Descargar Excel
          <img src="assets/svg/icon-download.svg" alt="Icono de descarga" />
        </button>
      </div> -->
      <!-- Banner e información -->
      <div class="container-imgs container-banner fts-16 font-regular">
        <div>
          <img
            src="assets/image/manage-order/banner-manage-order.svg"
            alt="Banner desktop"
            class="img-banner show-desktop-tablet"
          />
          <img
            src="assets/image/manage-order/banner-manage-order-mobile.svg"
            alt="Banner móvil"
            class="img-banner show-mobile pl-16"
          />
        </div>
        <div class="p-16 fts-14 font-regular line-height-16">
          Revisa tu bitácora de trabajo y registra tus nuevas iniciativas.
          <span class="font-bold-dali line-height-17"
            >Dale visibilidad a tus clientes de los acuerdos pactados</span
          >
          en este periodo, tus clientes podrán ver aquellos acuerdos en su Web
          de Clientes.
        </div>
      </div>
      <div class="register-btn-mobile">
        <ng-container *ngIf="isDataLoading; else buttonsAddSave">
          <div class="container-skeleton-button">
            <ngx-skeleton-loader
              count="1"
              appearance="line"
              [theme]="{
                height: '40px',
                width: '100%',
                'border-radius': '4px',
                'margin-bottom': '0px',
                display: 'flex'
              }"
            >
            </ngx-skeleton-loader>
          </div>
        </ng-container>
        <ng-template #buttonsAddSave>
          <!-- Botón de registrar -->
          <button
            *ngIf="
              (!isAddingRow && !isRowBeingEdited() && !isServiceError) ||
              isLoadingRegistrationService ||
              isErrorRegistrationService
            "
            class="btn-back-new fts-14 font-semiBold d-flex align-items-center btn-add-custom"
            [ngClass]="{
              'btn-register-disabled':
                isActionRetry ||
                isLoadingRegistrationService ||
                isErrorRegistrationService,
              'btn-add': !isActionRetry
            }"
            [disabled]="
              isActionRetry ||
              isLoadingRegistrationService ||
              isErrorRegistrationService
            "
            (click)="addNewRow()"
          >
            Registrar
            <mat-icon class="ml-8">add</mat-icon>
          </button>
          <ng-container
            *ngIf="
              (isAddingRow || isRowBeingEdited()) &&
              !(isLoadingRegistrationService || isErrorRegistrationService)
            "
          >
            <div
              class="d-flex align-items-center justify-content-end btn-add-custom"
            >
              <button
                mat-flat-button
                class="btn-cancel d-flex justify-content-center align-items-center mr-16"
                (click)="isAddingRow ? cancelAddRow(true) : cancelEditRow(true)"
              >
                Cancelar
              </button>

              <button
                [matMenuTriggerFor]="menuIncompleteForm"
                class="btn-back-new fts-14 font-semiBold d-flex align-items-center"
                [ngClass]="{ 'btn-add': true }"
                [disabled]="false"
                #menuTriggerIncompleteForm="matMenuTrigger"
                (click)="
                  isAddingRow
                    ? saveRow($event, menuTriggerIncompleteForm)
                    : editSaveRow($event, menuTriggerIncompleteForm)
                "
              >
                {{ successButton }}
              </button>
            </div>
          </ng-container>
        </ng-template>
      </div>
    </div>

    <!-- Tabla de bitácora -->
    <div class="mt-16 container-table-binnacle ">
      <div class="section-headers-filter align-items-center p-16">
        <div class="font-bold-dali fts-16 line-height-24 title-search">Reuniones, planes y acuerdos</div>
        <div class="align-items-center container-filters">
          <div class="container-search datepicker-input d-flex align-items-center">
            <button mat-icon-button matPrefix>
              <img src="/assets/svg/forms/search.svg" alt="search" />
            </button>
            <label for="binnacle-search" class="sr-only">Busca en la lista</label>
            <input id="binnacle-search" matInput placeholder="Busca en la lista" class="fts-14 font-regular input-search color-title-custom"
              [(ngModel)]="searchText" (ngModelChange)="onSearch()"/>
      
            <button mat-icon-button matSuffix *ngIf="searchText" (click)="clearSearch()">
              <img src="/assets/svg/forms/delete.svg" alt="clear" />
            </button>
          </div>
      
          <button mat-flat-button class="btn-cancel btn-filter mt-0 d-flex justify-content-center align-items-center"
            (click)="filterOpenModal()">
            Filtrar <span *ngIf="getActiveFiltersCount()>0">({{getActiveFiltersCount()}})</span>
            <img src="assets/image/sliders-horizontal _red.svg" alt="icono filtrar" class="ml-8 icon-img" />
      
          </button>
      
        </div>
      </div>
      <!-- Contenedor de la tabla -->
      <div
        class="table-scroll-container"
        [ngClass]="{
          'table-container':
            !isDataLoading &&
            !isServiceError &&
            dataSourceBinnacleList?.length > 0,
          'd-flex align-items-center justify-content-center table-skeleton-container':
            isDataLoading ||
            (!isServiceError &&
              (!dataSourceBinnacleList || dataSourceBinnacleList.length === 0)),
          'd-flex align-items-center justify-content-center error-container':
            isServiceError
        }"
      >
        <ng-container *ngIf="isDataLoading; else tableContent">
          <app-binnacle-skeleton></app-binnacle-skeleton>
        </ng-container>

        <ng-template #tableContent>
          <ng-container *ngIf="isServiceError; else noDataContent">
            <div class="container-null error">
              <div class="w-28">
                <app-message-empty-error
                  [messageError]="binnacleMessageError"
                  (retryDataError)="getBinnacleDataList(1, activeFilters)"
                ></app-message-empty-error>
              </div>
            </div>
          </ng-container>

          <ng-template #noDataContent>
            <ng-container
              *ngIf="dataSourceBinnacleList?.length > 0 && !isDataLoading; else emptyDataMessage"
            >
              <app-binnacle-table
                [dataSource]="dataSourceBinnacleList"
                [displayedColumns]="displayedColumns"
                [isAnyRowEditing]="isAnyRowEditing"
                [dateClients]="dateClients"
                [selectedClient]="selectedClient"
                [routinesList]="routinesList"
                [selectRoutines]="selectRoutines"
                [user]="user"
                [dataConvertClientSelect]="selectedClientCode"
                [rowErrors]="rowErrors"
                [isAddingRow]="isAddingRow"
                (editRow)="editRow($event)"
                (addNewRowEvent)="updatingValues($event)"
                (focusRow)="onFocus($event)"
                (blurRow)="onBlur($event)"
                (growRow)="autoGrow($event)"
                (isRowBeingEdited)="isRowBeingEdited()"
                (actionRetry)="
                  isActionRetry
                    ? saveRow($event, menuTriggerIncompleteForm)
                    : editSaveRow($event, menuTriggerIncompleteForm)
                "
                (toggleConfirmed)="handleToggleConfirmed($event)"
                [isLoadingRegistrationService]="isLoadingRegistrationService"
                [isErrorRegistrationService]="isErrorRegistrationService"
                [routinesListLoading]="routinesListLoading"
                [routinesMessageError]="routinesMessageError"
              >
              </app-binnacle-table>

              <!-- Indicador de carga y mensaje de fin -->
              <div class="loading-status-row" *ngIf="!isServiceError">
                <ng-container *ngIf="isLoadingMore">
                  <div class="loading-message d-flex align-items-center justify-content-center">
                    <div class="spinner-container d-flex align-items-center">
                      <mat-progress-spinner
                        mode="indeterminate"
                        [diameter]="20"
                        [strokeWidth]="2"
                        color="accent">
                      </mat-progress-spinner>
                    </div>
                    <span class="ml-2">Cargando más registros.</span>
                  </div>
                </ng-container>
                <div *ngIf="!hasMoreData && !isLoadingMore" class="end-message">
                  No hay más registros que mostrar.
                </div>
              </div>
            </ng-container>
            <ng-template #emptyDataMessage>
              <div class="container-null">
                <app-message-empty-error
                  [messageError]="(getActiveFiltersCount()>0 || searchText?.length>=3)?binnacleMessageNullFilters:binnacleMessageNull"
                ></app-message-empty-error>
              </div>
            </ng-template>
          </ng-template>
        </ng-template>
      </div>
      <div
        *ngIf="
          dataSourceBinnacleListInitial?.totalPages > 1 &&
          dataSourceBinnacleList?.length > 0
        "
        class="mt-16"
      >
        <!-- Eliminar el app-paginator existente -->
      </div>
    </div>
  </div>
  <button
    mat-flat-button
    class="scroll-to-top-btn"
    [ngClass]="{ 'show-scroll-btn': showScrollButton }"
    (click)="scrollToTop()"
  >
    <img src="assets/svg/top-icon.svg" alt="Subir" class="top-icon" />
    <span class="ml-4">Subir</span>
  </button>
</section>
<mat-menu #menuUser="matMenu">
  <app-profile
    [user]="user"
    [dateClients]="dateClients?.length ? true : false"
    (clientSelect)="clientSelect()"
  ></app-profile>
</mat-menu>
<mat-menu
  #menuIncompleteForm="matMenu"
  xPosition="before"
  yPosition="above"
  class="custom-menu-z-index mat-menu-incomplete"
>
  <div class="container-matmenu-delete">
    <div class="d-flex pb-3 align-items-center">
      <div class="icon-delete fts-18" emoji="⚠️">⚠️</div>
      <div class="font-regular fts-16 ml-8 line-height-20">
        Revisa tu información, aún tienes campos necesarios por completar.
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div>
        <button mat-raised-button color="accent" class="fts-14 font-semiBold">
          Entendido
        </button>
      </div>
    </div>
  </div>
</mat-menu>